
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"stroke":"#125bae","stroke-width":"2","stroke-linecap":"round","d":"M4 5h12M4 12h6M14 12h6M8 19h12"}}),_c('circle',{attrs:{"stroke":"#125bae","stroke-width":"2","stroke-linecap":"round","cx":"18","cy":"5","r":"2"}}),_c('circle',{attrs:{"stroke":"#125bae","stroke-width":"2","stroke-linecap":"round","cx":"12","cy":"12","r":"2"}}),_c('circle',{attrs:{"stroke":"#125bae","stroke-width":"2","stroke-linecap":"round","cx":"6","cy":"19","r":"2"}})])])
          )
        }
      }
    